import BaseApi from '../base'

const path = '/synergy/daily-report'
export default class DailyReportApi extends BaseApi {
  constructor() {
    super(path)
  }

  getTotalData = params => this.get(`${path}/total`, params)
  getDataByIds = params => this.get(`${path}/ids`, params)
  increasePrintedCount = params => this.put(`${path}/increase`, params)
  batchApprove = params => this.post('/admin/approval-history/batch-approval', params)
  // 批量获取详情
  getByIds = params => this.get(`${path}/get-by-ids`, params)
}
